import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './veiculoForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './veiculoActions';

const columns = [
    {
        field: 'placa_nome',
        type: 'text'
    },
    {
        field: 'odometro',
        type: 'text',
        formatter: row => row.odometro ? 'Sim' : 'Não'
    },
    {
        field: 'horimetro',
        type: 'text',
        formatter: row => row.horimetro ? 'Sim' : 'Não'
    }
];

const Veiculo = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'placa_nome',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc' ? 'desc' : 'asc';
            }

            return {
                field,
                direction
            };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.placa_nome || ''}
                ${item.observacao || ''}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(p => p.trim())
                .every(p => texto.includes(p.trim()));
        });

        return sortData(listaFiltrada, sort, columns);
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    odometro_formatado: item.odometro ? 'Sim' : 'Não',
                    horimetro_formatado: item.horimetro ? 'Sim' : 'Não'
                }))}
                name='Veículos'
            >
                <ExcelColumn label='Placa / Nome' value='placa_nome' />
                <ExcelColumn label='Odômetro' value='odometro_formatado' />
                <ExcelColumn label='Horímetro' value='horimetro_formatado' />
                <ExcelColumn label='Observação' value='observacao' />
                <ExcelColumn label='Usuário da Inclusão' value='nome_usuario_inclusao' />
                <ExcelColumn label='Usuário da Alteração' value='nome_usuario_alteracao' />
            </ExcelSheet>
        );
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div style={{ marginTop: 8, width: 270 }}>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => {
                                    props.setModoTela('cadastro', {});
                                    props.initForm({});
                                }}
                            >
                                <i className='fas fa-plus'></i> Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i> Atualizar
                            </button>

                            <ExcelFile
                                filename='Veículos'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i> Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='placa_nome'
                                    label='Placa / Nome'
                                    width={300}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='odometro'
                                    label='Odômetro'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='horimetro'
                                    label='Horímetro'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='observacao'
                                    label='Observação'
                                    width={300}
                                />

                                <Th sticky alignCenter width={50}></Th>
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, i) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : i % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.placa_nome}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.odometro ? 'Sim' : 'Não'}
                                    </Td>

                                    <Td
                                        onClick={() => setLinhaSelecionada(item.id)}
                                        alignCenter
                                    >
                                        {item.horimetro ? 'Sim' : 'Não'}
                                    </Td>

                                    <Td alignCenter
                                        onClick={() => setLinhaSelecionada(item.id)}
                                    >
                                        {item.observacao}
                                    </Td>

                                    <Td alignCenter minWidth={130} maxWidth={130}>
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible={true}
                                            title='Editar'
                                            event={() => {
                                                props.setModoTela('cadastro', {
                                                    ...item
                                                });

                                                props.initForm({
                                                    ...item
                                                });
                                            }}
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible={true}
                                            title='Excluir'
                                            event={() => {
                                                props.setModoTela('exclusao', {
                                                    ...item
                                                });

                                                props.initForm({
                                                    ...item
                                                });
                                            }}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form excluir onSubmit={props.excluir} />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.veiculo.modoTela,
    aguardando: state.veiculo.aguardando,
    lista: state.veiculo.lista
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Veiculo);